import { Separator } from "@/components/ui/separator";
import { Linkedin, Mail } from "lucide-react";
import { Link } from "react-router-dom";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_b5a08d36-4e1b-4658-ac05-a4f9da84b1e7/artifacts/uibwnn7l_InCred%20Global%20Asset%20Management.jpg";

const footerLinks = [
  { label: "Home", href: "#" },
  { label: "About Us", href: "#about" },
  { label: "Strategies", href: "#strategies" },
  { label: "Team", href: "#team" },
  { label: "Insights", href: "#insights" },
  { label: "Media", href: "#media" },
  { label: "Contact Us", href: "#contact" },
];

const groupLinks = [
  { label: "InCred Group", href: "https://www.incredgroup.com/" },
  { label: "InCred Global Wealth", href: "https://incredwealth.sg/" },
  { label: "InCred Asset Management", href: "https://www.incredassetmanagement.com/" },
];

const Footer = () => {
  const scrollTo = (href) => {
    if (href.startsWith("#")) {
      const el = document.querySelector(href);
      if (el) el.scrollIntoView({ behavior: "smooth" });
    } else {
      window.open(href, "_blank");
    }
  };

  return (
    <footer data-testid="footer" className="bg-[#0F172A] py-20">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          {/* Brand */}
          <div className="md:col-span-5">
            <img
              src={LOGO_URL}
              alt="InCred Global Asset Management"
              className="h-12 w-auto mb-6"
              data-testid="footer-logo"
            />
            <p className="text-sm text-slate-400 leading-relaxed font-body max-w-md" data-testid="footer-description">
              A Singapore-based asset management firm running diversified portfolios across public equities, Private Equity and Global credit.
            </p>
            <div className="flex items-center gap-4 mt-6">
              <a
                href="https://www.linkedin.com/company/77642194"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center bg-white/5 rounded-sm text-slate-400 hover:text-[#E87722] hover:bg-white/10 transition-all duration-300"
                data-testid="footer-linkedin"
              >
                <Linkedin className="h-4 w-4" />
              </a>
              <a
                href="mailto:info@incredglobalamc.sg"
                className="w-10 h-10 flex items-center justify-center bg-white/5 rounded-sm text-slate-400 hover:text-[#E87722] hover:bg-white/10 transition-all duration-300"
                data-testid="footer-email"
              >
                <Mail className="h-4 w-4" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="md:col-span-3">
            <h4 className="text-xs font-semibold text-white uppercase tracking-[0.15em] mb-6 font-heading" data-testid="footer-links-heading">
              Quick Links
            </h4>
            <nav className="flex flex-col gap-3">
              {footerLinks.map((link) => (
                <button
                  key={link.label}
                  onClick={() => scrollTo(link.href)}
                  className="text-left text-sm text-slate-400 hover:text-[#E87722] transition-colors duration-200 font-body"
                  data-testid={`footer-link-${link.label.toLowerCase().replace(/\s+/g, '-')}`}
                >
                  {link.label}
                </button>
              ))}
            </nav>
          </div>

          {/* InCred Group */}
          <div className="md:col-span-4">
            <h4 className="text-xs font-semibold text-white uppercase tracking-[0.15em] mb-6 font-heading" data-testid="footer-group-heading">
              InCred Group
            </h4>
            <nav className="flex flex-col gap-3">
              {groupLinks.map((link) => (
                <button
                  key={link.label}
                  onClick={() => scrollTo(link.href)}
                  className="text-left text-sm text-slate-400 hover:text-[#E87722] transition-colors duration-200 font-body"
                  data-testid={`footer-link-${link.label.toLowerCase().replace(/\s+/g, '-')}`}
                >
                  {link.label}
                </button>
              ))}
            </nav>
          </div>
        </div>

        <Separator className="my-12 bg-white/10" />

        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-slate-500 font-body" data-testid="footer-copyright">
            &copy; {new Date().getFullYear()} InCred Global Asset Management. All Rights Reserved.
          </p>
          <div className="flex items-center gap-6">
            <Link to="/terms-of-use" className="text-xs text-slate-500 hover:text-slate-300 transition-colors font-body" data-testid="footer-terms">
              Terms of Use
            </Link>
            <Link to="/privacy-policy" className="text-xs text-slate-500 hover:text-slate-300 transition-colors font-body" data-testid="footer-privacy">
              Privacy Policy
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
